import { Component, Input, SimpleChanges, OnInit, OnChanges, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ContactGroupService } from 'src/app/private/services/contact-group.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-contact-group-list',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './contact-group-list.component.html',
  styleUrls: ['./contact-group-list.component.scss']
})
export class ContactGroupListComponent implements OnInit, OnChanges {

  dataSource: any[] = [];
  @Input() currentSelectedContactGroupID: string | null = null;
  @Output() updatePreSelectedData = new EventEmitter<{ leadIds: any[]; contactIds: any[] }>();

  @Input() toggleFlag: boolean = false;

  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  loading: boolean = false;

  displayedColumns: Array<{ field: string, header: string, type: string }> = [];
  dataToEdit: any = {};

  openDeleteDialog: boolean = false;
  deleteLoading: boolean = false;
  contactToDelete: any = null;

  constructor(
    private api: ContactGroupService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.setDisplayColumns();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentSelectedContactGroupID']?.currentValue
      || changes['toggleFlag']
    ) {
      this.loadData({ first: 0, rows: this.rows });
    }
  }

  setDisplayColumns(): void {
    this.displayedColumns = [
      { field: 'name', header: 'Contact Name', type: 'contact_name' },
      { field: 'email', header: 'Email', type: 'email' },
      { field: 'phone', header: 'Phone', type: 'phone' },
      { field: 'source', header: 'Source', type: 'source' },
      { field: 'actions', header: 'Actions', type: 'actions' }
    ];
  }

  loadData(event: any){
    const page = event.first || 0;
    const size = event.rows || this.rows;

    if(!this.currentSelectedContactGroupID){
      return;
    }

    const payload = {
      where: {
        organization_id: this.localStorage.getOrganizationId(),
        contact_group_id: this.currentSelectedContactGroupID
      },
      filter: null,
      page,
      limit: size,
      order: {
        col: '"contact_group_list"."updatedAt"',
        dir: 'DESC'
      }
    };

    this.loading = true;

    this.api.getAllContactGroupList(payload).subscribe({
      next: (data) => {
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;

        let leadIds: any[] = [];
        let contactIds: any[] = [];

        this.dataSource.forEach(item => {
          if(item.lead_id){
            leadIds.push(item.lead_id);
          } else if(item.contact_id){
            contactIds.push(item.contact_id);
          }
        });

        this.updatePreSelectedData.emit({ leadIds, contactIds });

        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load contact groups.' });
        this.loading = false;
      },
    });
  }

  setTemplateEditData(template: any): void {
    this.dataToEdit = template;
  }

  getFullName(user: any): string {
    return [user?.prefix, user?.first_name, user?.last_name]
      .filter(Boolean)
      .join(' ') || 'N/A';
  }

  deleteContact(contact: any): void {
    this.contactToDelete = contact;
    this.openDeleteDialog = true;
  }

  closeDeleteDialog(): void {
    this.openDeleteDialog = false;
    this.contactToDelete = null;
  }

  confirmDelete(): void {
    if (!this.contactToDelete) {
      return;
    }

    this.deleteLoading = true;
    const payload = {
      id: this.contactToDelete.id
    };

    this.api.deleteContactGroupList(payload).subscribe({
      next: () => {
        this.messageService.add({ 
          severity: 'success', 
          summary: 'Success', 
          detail: 'Contact deleted successfully from the group.' 
        });
        this.deleteLoading = false;
        this.openDeleteDialog = false;
        this.contactToDelete = null;
        this.loadData({ first: 0, rows: this.rows });
      },
      error: () => {
        this.messageService.add({ 
          severity: 'error', 
          summary: 'Error', 
          detail: 'Failed to delete contact from the group.' 
        });
        this.deleteLoading = false;
        this.openDeleteDialog = false;
        this.contactToDelete = null;
      }
    });
  }
}